<template>
  <div>
    <div class="header mb-4">
      <h1 class="header-title">User Details</h1>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#">Dashboard</a>
          </li>
          <li class="breadcrumb-item">
            <a href="#">Users</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Details</li>
        </ol>
      </nav>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-if="!loading">
            <div class="row g-0">
              <div class="col-sm-3 col-xl-12 col-xxl-4 text-center">
                <img
                  :src="user.picture"
                  width="64"
                  height="64"
                  class="rounded-circle mt-2"
                  alt="AProfile Picture"
                />
              </div>
            </div>

            <table class="table table-sm my-2">
              <tbody>
                <tr>
                  <th>Name</th>
                  <td>{{ user.name }}</td>
                </tr>
                <tr>
                  <th>Email</th>
                  <td>{{ user.email }}</td>
                </tr>
                <tr>
                  <th>Role</th>
                  <td>{{ user.role }}</td>
                </tr>
                <tr>
                  <th>Status</th>
                  <td>
                    <span>{{ user.status }}</span>
                    <a href="#" @click.prevent="toggle" class="ms-5 btn btn-primary btn-sm" v-if="user.status == 'active' || user.status == 'suspended'">{{ user.status == 'active' ? 'suspend' : 'activate' }}</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <loading v-if="loading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.fetch();
  },

  data() {
    return {
      loading: true,
      user: {},
    };
  },

  methods: {
    fetch() {
      this.loading = true;

      this.$axios
        .get(`/api/v1/admin/users/${this.$route.params.id}`)
        .then((response) => {
          this.user = response.data.user;
          this.loading = false;
        });
    },

    toggle() {
      this.loading = true;

      this.$axios
        .put(`/api/v1/admin/users/${this.$route.params.id}`)
        .then((response) => {
          this.user = response.data.user;
          this.loading = false;
        });
    }
  },
};
</script>
